import { FC, useContext } from 'react';
import clsx from 'clsx';

import { DistanceProps } from './Distance.types';
import { useGetBreakpoint, getClassForBreakpoint } from '@marriott/mi-ui-library-shop';
import { logger } from '../../utils/index';
import { HQVContext } from '../../context';

export const getDistanceStr = (unitLabel: string, distance: number) => {
  if (unitLabel === 'mi' && distance) {
    return (distance / 1609.344).toFixed(1);
  } else if (unitLabel === 'km' && distance) {
    return (distance / 1000).toFixed(1);
  }
  return null;
};

export const Distance: FC<DistanceProps> = ({
  distanceUnitLabel,
  latitude,
  longitude,
  model,
  isReviewsSeparatorPresent,
}) => {
  const { log } = logger({})('HotelGalleryTitle/Distance');

  log.debug('Distance component: ', latitude, longitude);
  const breakpoint = useGetBreakpoint();
  const calcDistanceUnitLabel = distanceUnitLabel ? distanceUnitLabel : 'mi';
  const { hqvState } = useContext(HQVContext);

  if (!hqvState?.propertyDistanceValue) {
    // TODO: Replace with inline loader.
    return <div></div>;
  }

  return (
    <span>
      {hqvState?.propertyDistanceValue && (
        <span className="distance-container">
          {isReviewsSeparatorPresent && <span className="reviews-distance-separator">|</span>}
          <span className="icon-location distance-icon" />
          <span
            className={clsx(
              'title-title-container-list-miles',
              getClassForBreakpoint(breakpoint, 't-font-alt-s', 't-font-alt-s', 't-font-alt-s')
            )}
          >
            {`${hqvState?.propertyDistanceValue} ${calcDistanceUnitLabel}`}
          </span>
          <span
            className={clsx(
              'title-container-text',
              getClassForBreakpoint(breakpoint, 't-font-alt-s', 't-font-alt-s', 't-font-alt-s')
            )}
          >
            {model?.fromDestinationLabel}
          </span>
        </span>
      )}
    </span>
  );
};
